import lmsAPI from "../lmsAPI";

class locationBulkCSVExportService {
  async create({ locationIDs }) {
    const res = await lmsAPI.post(`/locations/csv_export.csv`, {
      location_ids: locationIDs,
    });
    return res.data;
  }
}

export default new locationBulkCSVExportService();
